export default "__VITE_ASSET__4eb2ab7b__"